import { useState } from "react";
import { useAuth } from "../auth/AuthProvider";
import { getAllFlags } from "../hooks/useFeatureFlag";

export default function Settings() {
  const { user, signOut } = useAuth();
  const [theme, setTheme] = useState("dark");
  const flags = getAllFlags();

  function handleExternalLink(url: string) {
    window.open(url, "_blank", "noopener");
  }

  function handleResetApp() {
    localStorage.clear();
    window.location.href = "/login";
  }

  return (
    <div className="flex-1 p-6 overflow-auto">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold text-white mb-6">Settings</h1>

        {/* Profile */}
        <section className="bg-dark-800 rounded-lg border border-dark-600 p-6 mb-4">
          <h2 className="text-lg font-semibold text-white mb-4">Profile</h2>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-dark-400">Name:</span>
              <span className="ml-2 text-white">{user?.name || "Guest"}</span>
            </div>
            <div>
              <span className="text-dark-400">Email:</span>
              <span className="ml-2 text-white">{user?.email || "—"}</span>
            </div>
            <div>
              <span className="text-dark-400">Role:</span>
              <span className="ml-2 text-white capitalize">{user?.role || "—"}</span>
            </div>
          </div>
        </section>

        {/* Appearance */}
        <section className="bg-dark-800 rounded-lg border border-dark-600 p-6 mb-4">
          <h2 className="text-lg font-semibold text-white mb-4">Appearance</h2>
          <label className="flex items-center gap-3 text-sm text-dark-200">
            Theme:
            <select
              value={theme}
              onChange={(e) => setTheme(e.target.value)}
              className="bg-dark-700 border border-dark-600 rounded px-3 py-1.5 text-white"
            >
              <option value="dark">Dark</option>
              <option value="light">Light</option>
              <option value="system">System</option>
            </select>
          </label>
        </section>

        {/* Feature Flags */}
        <section className="bg-dark-800 rounded-lg border border-dark-600 p-6 mb-4">
          <h2 className="text-lg font-semibold text-white mb-4">Feature Flags</h2>
          <div className="space-y-2">
            {Object.entries(flags).map(([key, enabled]) => (
              <div key={key} className="flex items-center justify-between text-sm">
                <code className="text-dark-300 font-mono text-xs">{key}</code>
                <span className={`px-2 py-0.5 rounded text-xs ${enabled ? "bg-green-900/50 text-green-300" : "bg-dark-700 text-dark-400"}`}>
                  {enabled ? "ON" : "OFF"}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* Links & Actions */}
        <section className="bg-dark-800 rounded-lg border border-dark-600 p-6">
          <h2 className="text-lg font-semibold text-white mb-4">Actions</h2>
          <div className="flex flex-wrap gap-3">
            <button
              onClick={() => handleExternalLink("https://docs.vulntask.dev")}
              className="px-4 py-2 bg-dark-700 text-dark-200 rounded hover:bg-dark-600 text-sm"
            >
              Documentation
            </button>
            <button
              onClick={() => handleExternalLink("https://status.vulntask.dev")}
              className="px-4 py-2 bg-dark-700 text-dark-200 rounded hover:bg-dark-600 text-sm"
            >
              System Status
            </button>
            <button
              onClick={handleResetApp}
              className="px-4 py-2 bg-yellow-900/50 text-yellow-300 rounded hover:bg-yellow-900/70 text-sm"
            >
              Reset App
            </button>
            <button
              onClick={signOut}
              className="px-4 py-2 bg-red-900/50 text-red-300 rounded hover:bg-red-900/70 text-sm"
            >
              Sign Out
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
